import JSencrypt from 'jsencrypt'
import CryptoJS from 'crypto-js'

class Cipher {

  rando (m) {
    let num = ''
    let getrandomarray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    for (let i = 0; i < m; i++) {
      let val = parseInt(Math.random() * 35, 10)
      if (i === 0 && val === 0) {
        i--
        continue
      }
      num += getrandomarray[val]
    }
    return num
  }

  MD5 (string) {
    return CryptoJS.MD5(string).toString()
  }

  RSAencrypt (publickey, string) {
    var encrypt = new JSencrypt.JSEncrypt()
    encrypt.setPublicKey(publickey, '10001')
    var encrypted = encrypt.encrypt(string)
    return encrypted
  }

  RSAprivateKeyEncrypt (privatekey, string) {
    var encrypt = new JSencrypt.JSEncrypt()
    encrypt.setPrivateKey(privatekey)
    var encrypted = encrypt.privateKeyEncrypt(string)
    return encrypted
  }

  RSApublicKeyDecrypt (publickey, string) {
    var decrypt = new JSencrypt.JSEncrypt()
    decrypt.setPublicKey(publickey)
    var uncrypted = decrypt.publicKeyDecrypt(string)
    return uncrypted
  }

  RSAdecrypt (privatekey, string) {
    var decrypt = new JSencrypt.JSEncrypt()
    decrypt.setPrivateKey(privatekey, '10001')
    var uncrypted = decrypt.decrypt(string)
    return uncrypted
  }

  AESencrypt (key, string) {
    var iv = CryptoJS.enc.Latin1.parse(key)
    var encrypted = CryptoJS.AES.encrypt(string, iv, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  }

  AESencryptAB (key, abv) {
    var iv = CryptoJS.enc.Latin1.parse(key)
    var data = CryptoJS.lib.WordArray.create(abv)
    var encrypted = CryptoJS.AES.encrypt(data, iv, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.ciphertext.toString()
  }

  AESdecrypt (key, string) {
    var iv = CryptoJS.enc.Latin1.parse(key)
    var decrypted = CryptoJS.AES.decrypt(string, iv, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    try {
      return decrypted.toString(CryptoJS.enc.Utf8)
    } catch (e) {
      console.log(e)
      return ''
    }
  }

  AESdecryptBase64 (key, base64Str) {
    var iv = CryptoJS.enc.Latin1.parse(key)
    var decrypted = CryptoJS.AES.decrypt(base64Str, iv, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return decrypted
  }

  AESencryptFilePart (key, block, blockSize, isEnd) {
    var iv = CryptoJS.enc.Latin1.parse(key)
    var data = CryptoJS.lib.WordArray.create(block)
    var encrypted = CryptoJS.AES.encrypt(data, iv, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    let enAbv = hex2abv(encrypted.ciphertext.toString())
    if (isEnd) {
      return enAbv
    } else {
      return enAbv.slice(0, blockSize)
    }
  }

  AESencryptFileByBlock (key, file, blockSize, callback, progressCB) {
    let blockId = 0
    let block
    let reader = new FileReader()
    let enBlockArr = []
    let that = this
    let curEndByte = 0

    reader.onloadend = function (evt) {
      let enRes = that.AESencryptAB(key, evt.target.result)
      let enAbv = hex2abv(enRes)
      if (curEndByte < file.size) {
        enBlockArr.push(enAbv.slice(0, blockSize))
      } else {
        enBlockArr.push(enAbv)
      }
      if (file.size === 0) {
        progressCB && progressCB(100)
      } else {
        progressCB && progressCB(Math.ceil((curEndByte / file.size) * 100))
      }
      blockId++
      if (blockId * blockSize < file.size) {
        curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size
        block = file.slice(blockId * blockSize, curEndByte)
        reader.readAsArrayBuffer(block)
      } else {
        let blob = new Blob(enBlockArr)
        callback && callback(blob)
      }
    }
    curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size
    block = file.slice(blockId * blockSize, curEndByte)
    reader.readAsArrayBuffer(block)
  }

  AESdecryptFileByBlock (key, file, originfilesize, blockSize, callback, progressCB) {
    if (!key) {
      console.error('aes decrypt failed, key is null,params is ', arguments)
      return callback('')
    }
    // key value length is 16.
    let keyLength = 16
    // split key value, keep the key length correct.
    key = key.substr(0, keyLength)

    let blockId = 0
    let block
    let reader = new FileReader()
    let deBlockArr = []
    let that = this
    let curEndByte = 0

    reader.onloadend = function (evt) {
      let data = CryptoJS.lib.WordArray.create(evt.target.result) // create wordArray
      let enBase64 = data.toString(CryptoJS.enc.Base64) // wordArray => base64
      let deWords = that.AESdecryptBase64(key, enBase64)
      if (file.size === 0) {
        progressCB && progressCB(100)
      } else {
        progressCB && progressCB(Math.ceil((curEndByte / file.size) * 100))
      }
      blockId++
      let isEnd = blockId * blockSize >= file.size
      let deAbv = wordToAB(deWords.words, deWords.sigBytes, isEnd) // wordArray => arrayBuffer
      deBlockArr.push(deAbv)
      if (!isEnd) {
        curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size
        block = file.slice(blockId * blockSize, curEndByte)
        reader.readAsArrayBuffer(block)
      } else {
        let blob = new Blob(deBlockArr)
        callback && callback(blob)
      }
    }
    curEndByte = (blockId + 1) * blockSize < file.size ? (blockId + 1) * blockSize : file.size
    block = file.slice(blockId * blockSize, curEndByte)
    reader.readAsArrayBuffer(block)
  }

}

// Convert a hex string to an ArrayBufferView
function hex2abv (hex) {
  if (hex.length % 2 !== 0) {
    hex = '0' + hex
  }
  let abv = new Uint8Array(hex.length / 2)
  for (let i = 0; i < abv.length; ++i) {
    abv[i] = parseInt(hex.substr(2 * i, 2), 16)
  }
  return abv
}

function wordToAB (wordArray, sigBytes, isEnd) {
  let byteArray = []
  let word
  let i
  let j
  for (i = 0; i < wordArray.length; ++i) {
    word = wordArray[i]
    for (j = 3; j >= 0; --j) {
      byteArray.push((word >> 8 * j) & 0xFF)
    }
  }
  // last block needs to split the useless bytes.
  if (isEnd) byteArray.length = sigBytes
  return new Uint8Array(byteArray)
}

// eslint-disable-next-line no-unused-vars
function wordToByteArray (word, length) {
  let ba = []
  let xFF = 0xFF
  if (length > 0) { ba.push(word >>> 24) }
  if (length > 1) { ba.push((word >>> 16) & xFF) }
  if (length > 2) { ba.push((word >>> 8) & xFF) }
  if (length > 3) { ba.push(word & xFF) }

  return ba
}

// eslint-disable-next-line no-unused-vars
function wordArrayToArrayBuffer (wordArray, length) {
  if (wordArray.hasOwnProperty('sigBytes') && wordArray.hasOwnProperty('words')) {
    length = wordArray.sigBytes
    wordArray = wordArray.words
  }

  let result = []
  let bytes
  let i = 0
  while (length > 0) {
    bytes = this.wordToByteArray(wordArray[i], Math.min(4, length))
    length -= bytes.length
    result.push(bytes)
    i++
  }
  return new Uint8Array([].concat.apply([], result))
}

// Convert an ArrayBufferView to a hex string
// eslint-disable-next-line no-unused-vars
function abv2hex (abv) {
  let b = new Uint8Array(abv)
  let hex = ''
  for (let i = 0; i < b.length; ++i) {
    let zeropad = (b[i] < 0x10) ? '0' : ''
    hex += zeropad + b[i].toString(16)
  }
  return hex
}

// eslint-disable-next-line no-unused-vars
function base64ToAB (base64) {
  let binarString = window.atob(base64)
  let len = binarString.length
  let bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binarString.charCodeAt(i)
  }
  return bytes.buffer
}

export default new Cipher()



// WEBPACK FOOTER //
// ./src/new-login-2018/common/Cipher.js